import { render, staticRenderFns } from "./CouponDetailDialog.vue?vue&type=template&id=3cf31c22&scoped=true"
import script from "./CouponDetailDialog.vue?vue&type=script&lang=ts"
export * from "./CouponDetailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf31c22",
  null
  
)

export default component.exports